import React from 'react';
import dragon from '../assets/dragon.jpg';

interface Table {
  id: string;
  type: 'square' | 'round';
  seats: number;
  status: 'available' | 'reserved' | 'selected';
}

const TableMap: React.FC<{
  onSelectTable: (tableId: string) => void;
  selectedTable: string | null;
}> = ({ onSelectTable, selectedTable }) => {

  const handleTableClick = (tableId: string) => {
    onSelectTable(tableId);
  };

  return (
    <div className="table-map-container">
      <h2>Restaurant Floor Plan</h2>
      <div className="table-map">
        <div className="dragon-decoration">
          <img src={dragon} alt="Dragon Decoration" className="dragon-image" />
        </div>

        {/* Top row of tables C1-C6 */}
        <div className="table-row top-row">
          <div
            className={`table round ${selectedTable === 'C1' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C1')}
          >
            <span className="table-id">C1</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C2' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C2')}
          >
            <span className="table-id">C2</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C3' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C3')}
          >
            <span className="table-id">C3</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C4' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C4')}
          >
            <span className="table-id">C4</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C5' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C5')}
          >
            <span className="table-id">C5</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C6' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C6')}
          >
            <span className="table-id">C6</span>
            <span className="table-seats">4 seats</span>
          </div>
        </div>

        {/* Center square table A */}
        <div className="center-table">
          <div
            className={`table square ${selectedTable === 'A' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('A')}
          >
            <span className="table-id">A</span>
            <span className="table-seats">8 seats</span>
          </div>
        </div>

        {/* Bottom row of tables C7-C12 */}
        <div className="table-row bottom-row">
          <div
            className={`table round ${selectedTable === 'C7' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C7')}
          >
            <span className="table-id">C7</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C8' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C8')}
          >
            <span className="table-id">C8</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C9' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C9')}
          >
            <span className="table-id">C9</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C10' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C10')}
          >
            <span className="table-id">C10</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C11' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C11')}
          >
            <span className="table-id">C11</span>
            <span className="table-seats">4 seats</span>
          </div>
          <div
            className={`table round ${selectedTable === 'C12' ? 'selected' : 'available'}`}
            onClick={() => handleTableClick('C12')}
          >
            <span className="table-id">C12</span>
            <span className="table-seats">4 seats</span>
          </div>
        </div>
      </div>

      <div className="table-legend">
        <div className="legend-item">
          <div className="legend-color available"></div>
          <span>Available</span>
        </div>
        <div className="legend-item">
          <div className="legend-color selected"></div>
          <span>Selected</span>
        </div>
        <div className="legend-item">
          <div className="legend-color reserved"></div>
          <span>Reserved</span>
        </div>
      </div>
    </div>
  );
};

export default TableMap; 